export const readHasExpirationDate = (product) =>
  product?.logisticsDetails?.hasExpirationDate ?? true;

export const buildNestedFieldUpdate = (path, value) => {
  if (!path.includes(".")) {
    return { [path]: value };
  }

  const parts = path.split(".");
  return parts.reduceRight((acc, key) => ({ [key]: acc }), value);
};
